import React from 'react'
import RegisterBody from '../../components/registercomponents/RegisterBody'


export default function FindCandidatesPage({onLogin}) {
  const intendedUrl = localStorage.getItem("intendedUrl");
  localStorage.clear();
  if (intendedUrl) {
    localStorage.setItem("intendedUrl", intendedUrl);
  }
  return (
    <div>
     {/* <FindCandidates /> */}
     <RegisterBody handleLogin={onLogin}/>
     {/* <Footer /> */}
    </div>
  )
}
